<template>
  <div class="app-connection-status" v-if="!isConnected">
    <span>Нет подключения к серверу</span>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Error",
  computed: {
    ...mapState(["isConnected"])
  }
};
</script>

<style lang="postcss">
.app-connection-status {
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 5px;
  padding: 10px;
  margin: 10px;
  color: white;
  background: red;
  font-size: 1em;
  width: auto;
  z-index: 99999;
}
</style>
